import React  from 'react'
import { Steps,} from 'antd'
// import { useSKspjdListQuery } from '../../store/DianShangYeWuApi';
function IncomeNodeAdd(props) {
    // const [items, setItems] = useState([]); 
    // const {data, isSuccess} = useSKspjdListQuery({ddsr_spjd_qy_id:props.qy_id,ddsr_spjd_user_id:props.user_id},{skip:!props.user_id});
    // useEffect(() => {
    //     if(isSuccess && data){
    //         if(data.Status === 'success' && data.Result){
    //             const sortedData = [...data.Result].sort((a, b) => {
    //                 return a.ddsr_spjd_xuhao - b.ddsr_spjd_xuhao;
    //             })
    //             const arr = sortedData.map((item) => ({
    //                 title:<span style={{fontSize:"14px",fontWeight:"bold"}}>{item.ddsr_spjd_name}</span>       ,
    //                 content:<span style={{fontSize:"12px"}}>{item.ddsr_spjd_yh_name}</span>,
    //             }))
    //             setItems([{
    //                 title:<span style={{fontSize:"14px",fontWeight:"bold"}}>创建</span>,
    //                 content:<span style={{fontSize:"12px"}}>{props.yh_name}</span>,
    //             },
    //             {
    //                 title:<span style={{fontSize:"14px",fontWeight:"bold"}}>提交</span>,
    //                 content:<span style={{fontSize:"12px"}}>{props.yh_name}</span>,
    //             },...arr]);
    //         }
    //     }
    // },[data, isSuccess, props.qy_id, props.user_id, props.yh_name])    
    const items = [
        {
            title: '创建',
            content: props.yh_name,
        },
        {
            title: '提交',
            content: '未提交',
        },
    ]
    return (
        <Steps items={items} current={0} size="small" titlePlacement="vertical" style={{width:'100%'}}/>
    )
}

export default IncomeNodeAdd